import { Link } from 'react-router';
import styles from './MainMenu.module.css';

const MainMenu = () => {
    return (
        <ul className={styles.mainmenu}>
            <li>
                <Link className={styles.menuTop} to="/">
                    Home
                </Link>
            </li>
            <li>
                <Link className={styles.menuMain} to="/database">
                    Database
                </Link>
            </li>
            <li>
                <Link className={styles.menuMain} to="/about">
                    About
                </Link>
            </li>
        </ul>
    );
};

export default MainMenu;
